import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, take } from 'rxjs';
import { AuthService } from 'src/app/features/services/auth/auth.service';
import { MyErrorStateMatcher } from 'src/app/shared/app-classes';
import { InternationalizationService } from 'src/app/shared/services/internationalization.service';
import { ToolsService } from 'src/app/shared/services/tools.service';
import { Location } from '@angular/common';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { async } from '@angular/core/testing';
import { RemoteApiService } from 'src/app/shared/services/remote-api.service';
import { environment } from 'src/app/environments/environments';
import { LoggingService } from 'src/app/shared/services/Logging.service';

@Component({
  selector: 'app-register-part2',
  templateUrl: './register-part2.component.html',
  styleUrls: ['./register-part2.component.scss']
})
export class RegisterPart2Component {
  userMoreDetailForm!: FormGroup;
  isConnected: boolean = false;
  disabled: boolean=true;
  IsAdded: boolean=false;
  user : any;
  userId: any;
  subUser : any;
  productId = "free_product";
  @Input() count = false;
  @Output() update = new EventEmitter<any>();
  platforms=[
    {"viewValue": "Custom", "value":"custom"},
    {"viewValue": "Shopify", "value":"shopify"},
    {"viewValue": "Woocommerce", "value":"woocommerce"},
  ]
  activities=[
    {"viewValue": "E-commerce", "value":"e-commerce"},
    {"viewValue": "Other", "value":"other"},
  ]
  countries: any;
  data: any;
  name: any;
  cell: any;
  company: any;
  platform: any;
  country: any;
  site: any;
  displayName: any;
  email: any;
  cellPhone: any;
  submitted : any;
  selectedCountry: any | undefined;
  constructor(private  auth: AuthService,
    private afs: AngularFirestore,
    private router: Router,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private tools:ToolsService,
    private titleService: Title,
    private Inter: InternationalizationService,
    private location: Location,
    private afAuth: AngularFireAuth,
    private RAS : RemoteApiService,
    private loggingService: LoggingService
   ) 
    {
      this.titleService.setTitle( 'Sign up' );
      this.data = this.location.getState()
      this.userMoreDetailForm = new FormGroup ({
      
        name: new FormControl(''),
        cell: new FormControl(''),
        company: new FormControl(''),
        site : new FormControl('', [Validators.required]),
        country: new FormControl(''),
        platform: new FormControl(''),
       
    });
    }

  matcher = new MyErrorStateMatcher();
  ngOnInit() {
    let test = 1 
    this.afAuth.authState.subscribe((user) => {
      this.loggingService.log('user from authstate',user)
      this.userId = user?.uid
      this.loggingService.log('user uid from authstate',this.userId)
      if (user && user?.emailVerified ) {

       this.userId = user?.uid
      } else {
        //this.snackBar.open('Your email is not verified please check you email again' , '', {duration: 4000});
      }
    });
   
     this.userId = this.route.snapshot.queryParams['idUser']
     this.loggingService.log('userUID from url param',  this.userId)
     this.countries=this.Inter.getAllCountry();
     this.loggingService.log(this.countries)
  }

  onTypeChange(type: string) { 
    this.loggingService.log('type',type)
    const siteControl = this.userMoreDetailForm.get('site');

    if (type === 'shopify') {
      siteControl?.setValidators([
        Validators.required,
        Validators.pattern('https:\\/\\/[a-zA-Z0-9-]+\\.myshopify\\.com'),
      ]);
    } else {
      siteControl?.setValidators([
        Validators.required,
        Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'),
      ]);
    }

    siteControl?.updateValueAndValidity(); // Refresh validation
  }



  extractHostname(url:string) {
    var hostname;
  
    if (url.indexOf("//") > -1) {
      hostname = url.split('/')[2];
    } else {
      hostname = url.split('/')[0];
    }

    hostname = hostname.split(':')[0];
    hostname = hostname.split('?')[0];
    hostname = hostname.replace('www.', '');
    return hostname;
  }

  async registerDetailClient() {
          // try { 
          if (this.userMoreDetailForm.valid)
           { 
            await  this.afs.doc('users/' + this.userId ).set(
                  {
                    displayName: this.userMoreDetailForm.controls['name'].value,
                    cell: this.userMoreDetailForm.controls['cell'].value,
                    company:this.userMoreDetailForm.controls['company'].value,
                    platform:this.userMoreDetailForm.controls['platform'].value,
                    shop_urls:[this.userMoreDetailForm.controls['site'].value],
                    country:this.userMoreDetailForm.controls['country'].value,
                    role: 'admin',
                    emailVerified: true,
                    pageID:[],
                    photoURL:"https://admin.favizone.com/assets/avatars/sunny-cc4fc62d561fc81d1065c02f02f3e0e3.png",
                  },{merge: true})
                  
                    let timezone = 'GMT+1'
                    const siteHostname = this.extractHostname(this.userMoreDetailForm.controls['site'].value);
                    const settingsSimilarDoc:{
                      n_results: number;
                      threshold: number;
                      similarity: string;
                      question_answer:boolean;
                    }={
                      n_results: 2,
                      threshold: 0.5,
                      similarity: 'COSINE',
                      question_answer:false,
                    }
                    const settingsAiKnowlegde: {
                      embeddingAlgorithm :object;
                      pdfAlgorithm :object;
                      maxDepth:number;
                      chunkMethod:object;
                      n_max_urls :number;
                      max_character:number;
                      chunkSize?: number;
                      chunkOverlap?: number;
                    } = {
                      embeddingAlgorithm : {name : 'OPENAI'},
                      pdfAlgorithm:{name : 'PyMuPDF'} ,
                      maxDepth: 2,
                      chunkMethod:{name : 'recursive'},
                      n_max_urls :100,
                      max_character:400000,
                      chunkSize:300,
                      chunkOverlap: 150
                    };
                    
                      this.RAS.postApi(`${environment.ingestKnowledgeBase}/workspaces`, 
                        {
                          "name": this.userMoreDetailForm.controls['site'].value,
                          "description": this.userMoreDetailForm.controls['site'].value,
                          "field_to_concatenate": {
                            "brand": "Ford",
                            "facets": [],
                            "price": 100,
                            "title": "Ford Mustang",
                            "description": "this is a description"
                          }
                        }
        
                      ).subscribe( async(resSubs: any) => {
                        if(siteHostname) { 
                          await this.afs.doc(`${this.userMoreDetailForm.controls['platform'].value}/${siteHostname}` ).set({
                            shopName: siteHostname,
                            shopUrl:this.userMoreDetailForm.controls['site'].value,
                            timezone: timezone,
                            connectedSince: formatDate(new Date(), 'dd/MM/yyyy, hh:mm:ss', "en-US"),
                            shopUuid: resSubs.id,
                            settingsAiKnowlegde:settingsAiKnowlegde,
                            settingsSimilarDoc:settingsSimilarDoc,
                            userID:this.userId
                            },{merge: true})
                      
                      }
                         
                      })
                    
                 
                    this.auth.redirectRouteSnapshot = this.route.snapshot;
                    this.router.navigate(['/home']);
                    this.count = true;
                    this.update.emit({ count: this.count });
              
                  }
        // }catch (error) {
        //   this.snackBar.open('Something went wrong, please try again', '', { duration: 4000 });
        // }

   
  }

  doLogin() {
    this.auth.redirectRouteSnapshot = this.route.snapshot;
    this.router.navigate(['auth/login']);
  }


 Iaccept(event: any)
 {
   this.disabled = false
 }
}
